import { PageContext } from 'context/PageContext';
import { useContext, useEffect } from 'react';
import { useAppSelector } from 'store/hooks';
import {
	pushToDataLayer,
	trackAddPaymentInfo,
	trackAddShippingInfo,
	trackBeginCheckoutViewItem,
	trackPageView,
} from '../services/TrackingService';

export const useTracking = () => {
	const { metaArea, theme } = useContext(PageContext) ?? {};
	const form = useAppSelector((state) => state.calculatorForm);

	useEffect(() => {
		trackPageView(theme);
		pushToDataLayer();
		setTimeout(() => {
			trackBeginCheckoutViewItem(metaArea, true);
			pushToDataLayer();
		}, 250);
	}, []);

	useEffect(() => {
		if (!form['SELECTED_PACKAGE_PAYMENT_FREQUENCY']) {
			return;
		}

		trackAddPaymentInfo(metaArea);
		// the next step shows the personal info step, so we can track add shipping info here as well
		trackAddShippingInfo(metaArea);
		pushToDataLayer();
	}, [form['SELECTED_PACKAGE_PAYMENT_FREQUENCY']]);
};
